import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Autoplay
    ]);
    new Swiper('.js-lp-testimonials', {
        pagination: {
            el: '.LandingpageTestimonials-pagination',
            type: 'bullets'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 3000
        },
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        effect: 'slide',
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: -50
            }
        }
    });
};
